import axios from "axios";
import Cookie from "./Cookie";
import { ME_API_URL } from "./apiUrl";

const TOKEN_KEY = "tlk_anon_token";
const DEVICE_KEY = "tlk_did";
const USER_KEY = "tlk_anon_user";
const FUNNEL_KEY = "tlk_funnel";
const FUNNEL_DAYS = 360;

export function getAnonToken() {
    try {
        return localStorage.getItem(TOKEN_KEY) || "";
    } catch (err) {
        return "";
    }
}

export function getDeviceKey() {
    try {
        return localStorage.getItem(DEVICE_KEY) || "";
    } catch (err) {
        return "";
    }
}

export function getFunnelVariant() {
    try {
        const stored = localStorage.getItem(FUNNEL_KEY);
        if (stored === "A" || stored === "B") return stored;
    } catch (err) {
        // Cookie is the fallback when storage is blocked.
    }
    const cookie = Cookie.getCookie(FUNNEL_KEY);
    return cookie === "A" || cookie === "B" ? cookie : "";
}

export function saveFunnelAssignment(data) {
    if (!data) return;
    try {
        if (data.device_key) localStorage.setItem(DEVICE_KEY, data.device_key);
        if (data.variant === "A" || data.variant === "B") {
            localStorage.setItem(FUNNEL_KEY, data.variant);
        }
    } catch (err) {
        // The cookie below still keeps the assignment on this browser.
    }
    if (data.variant === "A" || data.variant === "B") {
        Cookie.setCookie(FUNNEL_KEY, data.variant, FUNNEL_DAYS);
    }
}

export function hasAnonymousSession() {
    return Boolean(getAnonToken());
}

/** Chat calls keep using the guest token until claim clears it. */
export function authHeaderToken() {
    const anon = getAnonToken();
    if (anon) return anon;
    return Cookie.getCookie("__session") || "";
}

export function saveAnonymousSession(data) {
    localStorage.setItem(TOKEN_KEY, data.token);
    localStorage.setItem(DEVICE_KEY, data.device_key);
    if (data.user_id) localStorage.setItem(USER_KEY, data.user_id);
}

export function clearAnonymousSession() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
}

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Move the guest chat onto the Clerk user. Retries while the account row
 * is still being created. Leaves the guest token in place if it does not finish.
 */
export async function claimGuestTrial() {
    const anon = getAnonToken();
    if (!anon) return null;
    const base = process.env.REACT_APP_API_URL || "";

    for (let attempt = 0; attempt < 12; attempt += 1) {
        const session = Cookie.getCookie("__session");
        if (!session) {
            await wait(400);
            continue;
        }
        const headers = { Authorization: `Bearer ${session}` };
        try {
            const me = await axios.get(`${base}${ME_API_URL}`, { headers });
            if (me.status !== 200) {
                await wait(500);
                continue;
            }
            const claimed = await axios.post(
                `${base}/anonymous-sessions/claim`,
                { anonymous_token: anon },
                { headers },
            );
            const chat = claimed.data?.chats?.[0];
            if (chat?.chat_id) Cookie.setCookie("activeChatId", chat.chat_id, 1);
            clearAnonymousSession();
            window.dispatchEvent(new CustomEvent("tlk:trial-claimed", { detail: claimed.data }));
            return claimed.data;
        } catch (err) {
            const status = err?.response?.status;
            if (status === 404) {
                clearAnonymousSession();
                return null;
            }
            if (status === 409 || status === 401) {
                await wait(500);
                continue;
            }
            return null;
        }
    }
    return null;
}
